<template>
</template>

<script>
  export default {

    props: ["report"],

    data () {
      return {
        correspondingTypes: {
          "success": "complete-success",
          "warning": "info",
          "error": "danger"
        },
        correspondingMessage: {
          "success": '<i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Descendu dans SAP',
          "warning": '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Descente dans SAP avec erreur, contactez un administrateur',
          "error": '<i class="fa fa-ban" aria-hidden="true"></i> Migration vers SAP impossible'
        },
      }
    },

    computed: {

      result () {
        return !_.isNil(this.report) && this.report.result
      },

      status () {
        return this.result && this.result.status
      },

      type () {
        return this.status && this.correspondingTypes[this.status]
      },

      title () {
          return 'Création de client'
        // return this.result && this.result.customer.action.decoded_type
      },

      message () {
        let ret = this.status && this.correspondingMessage[this.status]
        // if (this.status === "error")
        //   ret += this.result.customer.message_bag[0].text
        return ret
      }
    },

    watch: {
      report (report) {
        !_.isNil(report) &&
          $('body').pgNotification({
            style: "circle",
            title: this.title,
            type: this.type,
            message: this.message,
            timeout: 7000,
          }).show()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Notificator.vue